import Dropdown from '../../../../shared/Inputs/Dropdown'
import usePersistentState from '../../../../shared/hooks/usePersistentState'
import { IPlan } from '../../promos.types'
import { useEffect, useMemo } from 'react'
import useHttpLoader from '../../../../hooks/useHttpLoader'
import promosApi from '../../promos.api'

interface IProps {
  plan: IPlan['id']
  name: string
  onChange: (val: IPlan['id'], name: string) => void

  autoSelect?: IPlan['billingCycle']
}

const PlanSelect = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [plans, setPlans] = usePersistentState<IPlan[]>([], 'plans', 'inMemory')

  useEffect(() => {
    wait(promosApi.getPlans(), (resp) => {
      if (resp.status === 'success') {
        if (props.autoSelect) {
          props.onChange(resp.body.find((p) => p.billingCycle === props.autoSelect)?.id, props.name)
        }
        setPlans(resp.body.filter((p) => p.code === 'ONCE' || p.code === 'VIP'))
      }
    })
  }, [])

  const options = useMemo(() => {
    return plans.map((p) => ({ title: p.title, value: p.id }))
  }, [plans])

  return (
    <Dropdown
      options={options}
      selectedOption={props.plan}
      title="План"
      name={props.name}
      onSelect={props.onChange}
      loading={loading}
    />
  )
}

export default PlanSelect
